import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Agents = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="agents icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M12 9C14.2091 9 16 7.20914 16 5C16 2.79086 14.2091 1 12 1C9.79086 1 8 2.79086 8 5C8 7.20914 9.79086 9 12 9Z"
    />
    <path
      className={pathClass}
      d="M4 12C5.65685 12 7 10.6569 7 9C7 7.34315 5.65685 6 4 6C2.34315 6 1 7.34315 1 9C1 10.6569 2.34315 12 4 12Z"
    />
    <path
      className={pathClass}
      d="M23 9C23 10.6569 21.6569 12 20 12C18.3431 12 17 10.6569 17 9C17 7.34315 18.3431 6 20 6C21.6569 6 23 7.34315 23 9Z"
    />
    <path
      className={pathClass}
      d="M0 24V17.5C0 15.2909 1.79086 13.5 4 13.5C5.21448 13.5 6.30255 14.0413 7.03615 14.8957C7.33448 12.4192 9.44311 10.5 12 10.5C14.5569 10.5 16.6655 12.4192 16.9639 14.8957C17.6974 14.0413 18.7855 13.5 20 13.5C22.2091 13.5 24 15.2909 24 17.5V24H0Z"
    />
  </svg>
)
